import ListeningSearch from '../../listening/curations/ListeningSearch.jsx';
import ListeningSavedSearchBuilder from '../../listening/curations/ListeningSavedSearchBuilder.jsx';
import Listening from '../../listening/curations/Listening.jsx';
import ListeningAccountUsage from '../../listening/curations/ListeningAccountUsage.jsx';
import ListeningQuidTopics from '../../listening/curations/ListeningQuidTopics.jsx';
import TikTokInsights from '../../insights/curations/TikTokInsights.jsx';
import TikTokInsightsVideos from '../../insights/curations/TikTokInsightsVideos.jsx';


RivalIQ.apps.Dashboard.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    // Mapping between the curation id and the React component to implement it.
    data.curationMapping = {
        [RivalIQ.enums.curation.LISTENING_SEARCH]: ListeningSearch,
        [RivalIQ.enums.curation.LISTENING_SAVED_SEARCH_BUILDER]: ListeningSavedSearchBuilder,
        [RivalIQ.enums.curation.LISTENING_SAVED_SEARCHES]: Listening,
        [RivalIQ.enums.curation.LISTENING_QUID_TOPICS]: ListeningQuidTopics,
        [RivalIQ.enums.curation.LISTENING_ACCOUNT_USAGE]: ListeningAccountUsage,
        [RivalIQ.enums.curation.TIKTOK_INSIGHTS]: TikTokInsights,
        [RivalIQ.enums.curation.TIKTOK_INSIGHTS_VIDEOS]: TikTokInsightsVideos
    };

    data.widgetMapping = {
    };

    // Register the widgets with the Dashboard automatically
    _.each(_.keys(data.widgetMapping), (widgetId) => {
        Marionette.Dashboard.widgets.add(widgetId, RivalIQ.apps.Dashboard.models.ReactWidgetBridge);
    });

});
